/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useState, useEffect } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
// import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
// import 'react-toastify/dist/ReactToastify.css'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
import Select from "react-select"
import ReactQuill from "react-quill";
import { toast } from 'react-toastify'
import { optionContext } from '../../../../utils/Context/optionContext'
// import ReactQuill from "react-quill";
const address = require('@bangladeshi/bangladesh-address')
//toast.configure({ autoClose: 2000 })
const Create = () => {
    const navigate = useNavigate()
    const { options, handleOptionToData } = useContext(optionContext)
    const [error, setError] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [faqs, setFaqs] = useState([]);
    const [newFaq, setNewFaq] = useState({ question: "", answer: "" });
    const [value, setValue] = useState("");
        const handleChange = (content) => {
        setValue(content);
        // console.log(content);
        
        // if (onChange) onChange(content);
    };

    const [profession, setProfession] = useState();
    const [district, setDistrict] = useState();

    const [newProfessionArea, setProfessionArea] = useState({
              value: null,
              options: []
          })

    useEffect(() => {
            // setQualification({ ...newQualification, options: handleOptionToData("Qualification") })
            // setWorkingWith({ ...newWorkingWith, options: handleOptionToData("Working with") })
            setProfessionArea({ ...newProfessionArea, options: handleOptionToData("Profession area") })
            // setAnnualIncome({ ...annualIncome, options: handleOptionToData("Income") })
        }, [options])
    
    const rawDistict = address.allDistict();
        const all_Distict = rawDistict.map(div => ({
                value: div,
                label: div
            }));

        // Add FAQ
        const addFaq = () => {
            if (!newFaq.question.trim() || !newFaq.answer.trim()) return alert("Please enter both question and answer!");
            setFaqs([...faqs, newFaq]);
            setNewFaq({ question: "", answer: "" });
        };
    
        // Remove FAQ
        const removeFaq = (index) => {
            const updatedFaqs = faqs.filter((_, i) => i !== index);
            setFaqs(updatedFaqs);
        };
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    const [items, setItems] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const addItem = () => {
        if (inputValue.trim() === "") return;
        setItems([...items, inputValue]);
        setInputValue("");
    };

    const removeItem = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };

    // Handle image
    const handleImage = event => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 300) {
                setError({ ...error, image: 'Select less than 300KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })
            setError({ ...errors, image: null })
        }
    }

    // Submit Form
    const onSubmit = async (data) => {
        try {
            if (!selectedFile) return setError({ ...error, image: 'Image is required' })

            setLoading(true)
            let formData = new FormData()
            formData.append('metaTitle', data.metaTitle)
            formData.append('metaDescription', data.metaDescription)
            formData.append('title', data.title)
            formData.append('subBannerTitle', data.subBannerTitle)
            formData.append('bannerDescription', data.bannerDescription)
            formData.append('district', district)
            formData.append('profession', profession)
            formData.append('description', value)
            formData.append("faq", JSON.stringify(faqs));
            formData.append("profileVerification", JSON.stringify(items));
            formData.append('image', selectedFile.image)

            
            const res = await Requests.ProfilesByProfession.Store(formData, header)
            console.log(res.status);
            
            if (res.status === true) {
                setLoading(false)
                navigate('/dashboard/website/profiles-by-profession')
                toast.success(res.message)
                
            }else{
                setLoading(false)
                 toast.error(res.message || "Something went wrong");
                // navigate('/dashboard/website/profiles-by-profession')
            }
        } catch (error) {
            if (error) console.log(error)
        }
    }

    return (
        <div className="store-story pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Profiles By Profession</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/story"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    {/*  Meta Title */}
                                    <div className="col-12">
                                        <div className="form-group mb-4">
                                            {errors.metaTitle && errors.metaTitle.message ? (
                                                <p className="text-danger">{errors.metaTitle && errors.metaTitle.message}</p>
                                            ) : <p>Meta Title</p>
                                            }

                                            <input
                                                type="text"
                                                name="metaTitle"
                                                className="form-control shadow-none"
                                                placeholder="Enter Meta Title"
                                                {...register("metaTitle", { required: "Title is required" })}
                                            />
                                        </div>
                                    </div>

                                    {/* metaDescription */}
                                    <div className="form-group mb-4">
                                        {errors.metaDescription && errors.metaDescription.message ? (
                                            <p className="text-danger">{errors.metaDescription && errors.metaDescription.message}</p>
                                        ) : <p>Meta Description</p>}

                                        <textarea
                                            type="text"
                                            name="metaDescription"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Meta Description"
                                            {...register("metaDescription", { required: "Description is required" })}
                                        />
                                    </div>

                                        <div className="row">

                                        {/* Title */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.title && errors.title.message ? (
                                                    <p className="text-danger">{errors.title && errors.title.message}</p>
                                                ) : <p>Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Title"
                                                    {...register("title", { required: "Title is required" })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.subBannerTitle && errors.subBannerTitle.message ? (
                                                    <p className="text-danger">{errors.subBannerTitle && errors.subBannerTitle.message}</p>
                                                ) : <p>Sub banner title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="subBannerTitle"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Sub banner title"
                                                    {...register("subBannerTitle", { required: "Sub banner title is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* link */}
                                        {/* <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.link && errors.link.message ? (
                                                    <p className="text-danger">{errors.link && errors.link.message}</p>
                                                ) : <p>Link</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="link"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter link"
                                                    {...register("link", { required: "link is required" })}
                                                />
                                            </div>
                                        </div> */}


                                    </div>

                                    {/* description */}
                                    <div className='row'>
                                        {/* <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.link && errors.link.message ? (
                                                    <p className="text-danger">{errors.link && errors.link.message}</p>
                                                ) : <p>Banner title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="link"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Banner title"
                                                    {...register("link", { required: "Banner title is required" })}
                                                />
                                            </div>
                                        </div> */}
                                        
                                    </div>
                                    <div className="form-group mb-4">
                                        {errors.bannerDescription && errors.bannerDescription.message ? (
                                            <p className="text-danger">{errors.bannerDescription && errors.bannerDescription.message}</p>
                                        ) : <p>Banner Short Description</p>}

                                        <textarea
                                            type="text"
                                            name="bannerDescription"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Banner short description"
                                            {...register("bannerDescription", { required: "Banner Description is required" })}
                                        />
                                    </div>
                                    
                                    {/* <div className="form-group mb-4">
                                        {errors.description && errors.description.message ? (
                                            <p className="text-danger">{errors.description && errors.description.message}</p>
                                        ) : <p>Banner Short Description(Bangla)</p>}

                                        <textarea
                                            type="text"
                                            name="description"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter blog short description"
                                            {...register("description", { required: "Description is required" })}
                                        />
                                    </div> */}

                                    <div className='row'>
                                        {/* <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.title && errors.title.message ? (
                                                    <p className="text-danger">{errors.title && errors.title.message}</p>
                                                ) : <p>Bright vs Groom Name</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Bright vs Groom Name"
                                                    {...register("title", { required: "Bright vs Groom Name is required" })}
                                                />
                                            </div>
                                        </div> */}
                                        
                                        {/*  District */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>District</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    options={all_Distict}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    onChange={(event) => setDistrict(event.value)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>Profession</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    options={newProfessionArea.options}
                                                    // options={items}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    onChange={(event) => setProfession(event.value)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                        {/*  Area Name */}
                                        {/* <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.areaName && errors.areaName.message ? (
                                                    <p className="text-danger">{errors.areaName && errors.areaName.message}</p>
                                                ) : <p>Country Name</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    // options={items}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    // onChange={(event) => handleAssignTo(event)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div> */}

                                        {/* <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.link && errors.link.message ? (
                                                    <p className="text-danger">{errors.link && errors.link.message}</p>
                                                ) : <p>Joined Date</p>
                                                }

                                                <input
                                                    type="date"
                                                    name="link"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter link"
                                                    {...register("link", { required: "link is required" })}
                                                />
                                            </div>
                                        </div> */}
                                    </div>

                                    {/* description */}
                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                        <p className="section-title mb-3">Description</p>

                                        <ReactQuill
                                            value={value}
                                            onChange={handleChange}
                                            theme="snow"
                                            rows={5}
                                            className="bg-white"
                                        />
                                    </div>

                                    <div className="form-group mb-4">
                                        {errors.membersAreKnown && errors.membersAreKnown.message ? (
                                            <p className="text-danger">{errors.membersAreKnown && errors.membersAreKnown.message}</p>
                                        ) : <p>Profile Verification</p>}

                                        <ul className="list-group mb-3">
                                            {items.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {item}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => removeItem(index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>

                                        <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                                            <input
                                                type="text"
                                                placeholder="Enter members are known"
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                style={{
                                                    flex: "1",
                                                    padding: "6px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                            <div
                                                onClick={addItem}
                                                className='btn btn-sm btn-danger'
                                                // style={{
                                                //     backgroundColor: "#007bff",
                                                //     color: "white",
                                                //     border: "none",
                                                //     borderRadius: "4px",
                                                //     padding: "6px 12px",
                                                //     cursor: "pointer",
                                                // }}
                                            >
                                                Add
                                            </div>
                                        </div>
                                    </div> 
                                    
                                    {/* FAQ*/}
                                    <div className="form-group mb-4">
                                        {errors.description && errors.description.message ? (
                                            <p className="text-danger">{errors.description && errors.description.message}</p>
                                        ) : <p>FAQ </p>}

                                        {faqs.length > 0 ? (
                                            faqs.map((faq, index) => (
                                                <div key={index} className="border rounded p-3 mb-3 bg-light">
                                                    <h6 className="fw-semibold mb-2">
                                                        {index + 1}. {faq.question}
                                                    </h6>
                                                    <p className="mb-2">{faq.answer}</p>
                                                    <div className='flex justify-content-end'>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => removeFaq(index)}
                                                    >
                                                        Remove
                                                    </button></div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-muted"></p>//No FAQs added yet.
                                        )}

                                        {/* ✅ Add New FAQ */}
                                        <div className="border rounded p-3 bg-white">
                                            <h6 className="fw-semibold mb-3">Add New FAQ</h6>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Enter question"
                                                value={newFaq.question}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, question: e.target.value })
                                                }
                                            />
                                            <textarea
                                                className="form-control mb-2"
                                                rows={3}
                                                placeholder="Enter answer"
                                                value={newFaq.answer}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, answer: e.target.value })
                                                }
                                            />
                                            <div className="btn btn-success" onClick={addFaq}>
                                                Add FAQ
                                            </div>
                                        </div>
                                    </div>

                                    {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                        <div className="d-flex">
                                            {selectedFile && selectedFile.preview ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Image upload Container */}
                                    {/* <div className="form-group mb-4">
                                        {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Gallery Images</p>}
                                        <div className="d-flex">
                                            {selectedFile && selectedFile.preview ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Creating...' : 'Create'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        height: 40,
        fontSize: 13,
        color: "#000",
        minWidth: 170,
        boxShadow: "none",
        "&:hover": { borderColor: "1px solid #ced4da" },
        border: state.isFocused ? "1px solid #dfdfdf" : "1px solid #ced4da",
        borderRadius: 0,
        menuPortal: base => ({ ...base, zIndex: 999 })
    }),
};